import styled from 'styled-components';
import { getDefaultForegroundColor } from '@mews-ui/theme';
import { Positioner } from '@optimus-web/helpers';
import { ANIMATION_CURVE, ELEVATION } from '@optimus-web/local-tokens';

export interface StyledPositionerProps {
    visible?: boolean;
    minWidth?: number;
}

export const StyledPositioner = styled(Positioner)<StyledPositionerProps>`
    display: flex;
    flex-direction: column;
    background-color: ${getDefaultForegroundColor};
    border-radius: 8px;
    box-shadow: ${ELEVATION[50]};
    opacity: 0;
    overflow-x: hidden;
    overflow-y: auto;
    outline: none;
    transition: opacity 120ms ${ANIMATION_CURVE.default};
    z-index: 10000;
    min-height: 16px;
    min-width: ${(props) => props.minWidth}px;
    ${(props) => (props.visible ? 'opacity: 1;' : 'pointer-events: none;')}

    /* Prevents content scrolling issue in Chrome */
    will-change: opacity;
`;
